ACC.adduserpopup = {

  addUserFormIdGlobal: '#cboxContent #ph-mycompany_adduser__form',
  approverSelectFieldGlobal: '.ph-approver_selectfield .ph-formselect',
  isEditUserClickGlobal: '.ph-mycompany_adduser__email .ph-isEditUserClick',
  isDuplicateEmailGlobal: '.ph-isDuplicateEmail',
  formInputGlobal: '.ph-forminput',
  formSelectGlobal: '.ph-formselect',
  formFieldWrapGlobal: '.ph-form__fieldwrap',
  emptyValueGlobal: '.ph-register__emptyvalue',
  addUserEditHeading: '#cboxContent .ph-mycompany_edituser__heading',
  addUserAddHeading: '#cboxContent .ph-mycompany_adduser__heading',
  muSrcPermission: '.ph-mu-srcpermission',

  adduser: function() {
    $(document).on('click', '.ph-mycompany__addnewuser-button', function() {
      var addUserUrl = $('.ph-addUserUrl').text();

      $('#ph-mycompany_adduser__form').attr('action', addUserUrl);

      $('select').selectBox('destroy');
      ACC.adduserpopup.adduserclick();

      $(ACC.adduserpopup.addUserEditHeading).addClass('hidden');
      $(ACC.adduserpopup.addUserAddHeading).removeClass('hidden');
    });

    $(document).on('click', '.ph-mycompany__usersrow-tooltip--edit, .ph-mycompany__usersrow-name', function() {
      var editUserUrl = $('.ph-editUserUrl').text();

      $('#ph-mycompany_adduser__form').attr('action', editUserUrl);

      $('select').selectBox('destroy');
      ACC.adduserpopup.adduserclick();

      $(ACC.adduserpopup.addUserEditHeading).removeClass('hidden');
      $(ACC.adduserpopup.addUserAddHeading).addClass('hidden');

      var userId = $(this).attr('data-userid');

      var $formField = $('#cboxContent .ph-mycompany_adduser__fields'),
          $appendFirstName = $formField.find('.ph-mycompany_adduser__firstname .ph-forminput'),
          $appendLastName = $formField.find('.ph-mycompany_adduser__lastname .ph-forminput'),
          $appendPhNo = $formField.find('.ph-mycompany_adduser__phNo .ph-forminput'),
          $appendEmailId = $formField.find('.ph-mycompany_adduser__email .ph-forminput'),
          $appendDepartment = $('#cboxContent .ph-mycompany_adduser__department--main .ph-mycompany_adduser__department .ph-formselect');

      $formField.find(ACC.adduserpopup.isEditUserClickGlobal).val('true');
      $('#cboxContent .ph-mycompany__adduserpopup--main').find('.ph-mycompany_adduser__buttons .ph-oldEmailId').val(userId);

      $.ajax({
        url: ACC.config.contextPath + '/my-account/manage-users/editUserDetails',
        type: 'GET',
        data: {
          userid: userId
        },
        async: false,
        dataType: 'json',
        success: function(result) {
          $formField.find('.uid,#uid').val(result.uid);
          $('.ph-mycompany_adduser__title .ph-formselect').val(result.titleCode);
          $appendFirstName.val(result.firstName);

          if (result.firstName) {
            $appendFirstName.attr('readonly', 'true');
          }

          $appendLastName.val(result.lastName);

          if (result.lastName) {
            $appendLastName.attr('readonly', 'true');
          }

          $appendPhNo.val(result.phoneNumber);

          $appendEmailId.val(result.displayUid);

          if (result.displayUid) {
            $appendEmailId.attr('readonly', 'true');
            $appendEmailId.addClass('disabled');
            $appendEmailId.css('text-align', 'initial');
          }

          $appendDepartment.val(result.department);

          if (result.organizationData) {
            $.each(result.organizationData, function(index, salesOrg) {
              if (salesOrg) {
                $.each(salesOrg.b2bUnitInfo, function(innerIndex, b2bUnit) {
                  if (b2bUnit) {
                    $('#cboxContent input[name="selectedB2BUnit"]').each(function() {
                      if (b2bUnit.selected === true && b2bUnit.soldToNumber === $(this).val()) {
                        $(this).prop({
                          checked: 'checked',
                          disabled: 'true'
                        });
                        $(this).closest('.ph-labelregcontainer').addClass('ph-selectedInputBox');
                      }
                    });
                  }
                });
              }
            });
          }
        }
      });
    });
  },

  salesOrgPermission: function() {
    var salesOrgName = '',
        availableSrc = false,
        availableMatc = false,
        availableSps = false,
        $cboxDiv = $('#cboxContent .ph-mycompany_adduser__fields');


    $('#cboxContent input[name="selectedB2BUnit"]:checked').each(function() {
      salesOrgName = $(this).parents('.ph-managerusers__organizationsection').find('.ph-salesOrgValue').html();

      if (salesOrgName === '1000') {
        availableSrc = true;
      }

      if (salesOrgName === 'US90') {
        availableMatc = true;
      }

      if (salesOrgName === 'US93') {
        availableSps = true;
      }
    });

    $(ACC.adduserpopup.muSrcPermission).find('.ph-adduser_permission').removeAttr('disabled', 'disabled');
    $(ACC.adduserpopup.muSrcPermission).removeClass('ph-disabledPermission');
    $('.ph-mu-srcpermissiononly').addClass('hidden');

    if (availableSrc === true && availableMatc === false && availableSps === false) {
      $(ACC.adduserpopup.muSrcPermission).removeClass('hidden');
    } else if ($cboxDiv.find(ACC.adduserpopup.isEditUserClickGlobal).val() === 'true') {
      if (availableSrc === true && (availableMatc === true || availableSps === true)) {
        $(ACC.adduserpopup.muSrcPermission).removeClass('hidden');
        $(ACC.adduserpopup.muSrcPermission).find('.ph-adduser_permission').attr('disabled', 'disabled');
        $(ACC.adduserpopup.muSrcPermission).addClass('ph-disabledPermission');
        $('.ph-mu-srcpermissiononly').removeClass('hidden');
      } else {
        $(ACC.adduserpopup.muSrcPermission).addClass('hidden');
      }
    } else {
      $(ACC.adduserpopup.muSrcPermission).addClass('hidden');
    }
  },

  checkCheckedAttr: function() {
    var $cboxDiv = $('#cboxContent .ph-mycompany_adduser__fields');

    if ($cboxDiv.find(ACC.adduserpopup.isEditUserClickGlobal).val() === 'false') {
      if ($('.ph-valueone').html() === 'true') {
        $('#cboxContent .mucheckboxs').attr('checked', 'checked');
      }
    }
  },

  adduserclick: function() {
    $('.ph-company-permissions').addClass('hidden');
    $('.ph-company-details').removeClass('hidden');
    $.colorbox({
      html: $('.ph-mycompany__adduserpopup').html(),
      maxWidth: '542px',
      width: '100%',
      height: 'auto',
      close: '<button type=\'button\' id=\'ph-cboxClose\' class=\'ph-favclose\'><span class=\'ph-icon-cross ph-favcross\'></span></button>',
      onComplete: function() {
        $('select').selectBox();
        $('#colorbox').addClass('ph-mycompany__adduser--popupcenter');

        var $department = $('#cboxContent .ph-mycompany_adduser__department--main'),
            departmentOption = $department.attr('data-addDepartment');

        $department.find(ACC.adduserpopup.formSelectGlobal).removeAttr('disabled');
        $department.find('.ph-mycompany_adduser__department--new .ph-forminput').removeAttr('disabled');
        $department.find('.ph-mycompany_adduser__department').removeClass('hidden');
        $department.find('.ph-mycompany_adduser__department--new').addClass('hidden');

        $department.find(ACC.adduserpopup.formSelectGlobal).append('<option>' + departmentOption + '</option>');

        $('select').selectBox('destroy');
        $('select').selectBox();
        ACC.common.refreshSelectBoxArrow();

        ACC.adduserpopup.checkCheckedAttr();

        var $placeOrderSelect = $('#cboxContent .ph-permissions__placeorder-main fieldset'),
            $placeOrderSelecttext = $placeOrderSelect.find('.ph-formselecttext'),
            $placeOrderSelectLabel = $placeOrderSelect.find('.ph-formlabel, .selectBox-label');

        $placeOrderSelecttext.attr('disabled', true);

        $('input.ph-adduser_permission[type="radio"]').on('click', function() {
          var permissionSelection = $('.ph-adduser_permission:checked').val();

          if (permissionSelection === 'placing_and_managing_orders') {
            ACC.adduserpopup.removePermissionSelection($placeOrderSelecttext, $placeOrderSelectLabel);
            $placeOrderSelecttext.removeAttr('disabled');
          } else {
            ACC.adduserpopup.addPermissionSelection($placeOrderSelecttext, $placeOrderSelectLabel);
            $placeOrderSelecttext.attr('disabled', true);
          }
        });

        $(document).on('click', '.ph-mycompany_adduser__nextbutton', function(e) {
          var validationValue = ACC.adduserpopup.validateAddNewUserForm();

          var isDuplicateEmail = $(ACC.adduserpopup.isDuplicateEmailGlobal).val();

          var $emailTraverse = $(this).closest('.ph-mycompany__adduserpopup--main'),
              editUserClick = $emailTraverse.find(ACC.adduserpopup.isEditUserClickGlobal).val();

          if (editUserClick === 'true') {
            ACC.adduserpopup.validateWithoutEmail(validationValue, e);
          } else {
            ACC.adduserpopup.validateWithEmail(validationValue, isDuplicateEmail, e);
          }

          ACC.adduserpopup.salesOrgPermission();
        });

        $(document).on('click', '.ph-mycompany_adduser__savebutton', function(e) {
          var validationValue = ACC.adduserpopup.validatePermissionAddNewUserForm();

          ACC.adduserpopup.validateWithoutEmail(validationValue, e);
        });

        $(document).on('blur', '#cboxContent .ph-mycompany_adduser__department--new .ph-forminput', function() {
          if ($(this).val() === '') {
            var $departmentValidation = $('#cboxContent .ph-mycompany_adduser__department--new'),
                departmentValidationErrorMsg = $departmentValidation.attr('data-emptyContent');

            ACC.adduserpopup.companyFieldsRemoveErrorMsg($departmentValidation, departmentValidationErrorMsg);
          }
        });

        $(document).on('blur', '#cboxContent .ph-mycompany_adduser__email .ph-forminput', function() {
          $('.ph-adduser_validatingemail').removeClass('hidden');

          var $emailTraverse = $(this).closest('.ph-mycompany__adduserpopup--main'),
              editUserClick = $emailTraverse.find(ACC.adduserpopup.isEditUserClickGlobal).val();

          if (editUserClick === 'false') {
            ACC.adduserpopup.duplicateEmailCheck();
          }

          $('.ph-adduser_validatingemail').addClass('hidden');
        });

        $(document).on('change', '#cboxContent .ph-mycompany_adduser__department--main .ph-formselect', function() {
          var optionValue = $(this).val();

          if (optionValue === departmentOption) {
            $department.find('.ph-mycompany_adduser__department--new').removeClass('hidden');
            $department.find('.ph-mycompany_adduser__department').addClass('hidden');
            $(this).attr('disabled', true);
          } else {
            $department.find('.ph-mycompany_adduser__department--new .ph-forminput').attr('disabled', true);
          }
        });
      },

      onClosed: function() {
        ACC.common.refreshScreenReaderBuffer();
      }
    });
  },

  inputFieldAddUser: function(count) {
    var index = count;

    $('#cboxContent .ph-mycompany_adduser__fields .form_field-input').each(function() {
      var $this = $(this),
          inputValue = $this.find('.ph-forminput, .ph-formselect').val(),
          errormsgValue = $this.attr('data-emptyContent');

      /* eslint-disable no-undefined*/
      if (inputValue === '' || inputValue === null || inputValue === undefined || $.trim(inputValue) === '') {
        /* eslint-enable no-undefined*/

        index = index + 1;

        ACC.adduserpopup.companyFieldsAddErrorMsg($this, errormsgValue);
      } else {
        ACC.adduserpopup.companyFieldsRemoveErrorMsg($this);
      }
    });
  },
  /* eslint-disable max-statements*/
  validateAddNewUserForm: function() {
    var count = 0;

    ACC.adduserpopup.inputFieldAddUser(count);

    var $firstNameValidation = $('#cboxContent .ph-mycompany_adduser__firstname'),
        firstNameValidationErrorMsg = $firstNameValidation.attr('data-emptyContent'),
        $firstName = $firstNameValidation.find(ACC.adduserpopup.formInputGlobal),

        $lastNameValidation = $('#cboxContent .ph-mycompany_adduser__lastname'),
        lastNameValidationErrorMsg = $lastNameValidation.attr('data-emptyContent'),
        $lastName = $lastNameValidation.find(ACC.adduserpopup.formInputGlobal),

        $phNoValidation = $('#cboxContent .ph-mycompany_adduser__phNo'),
        phNoValidationErrorMsg = $phNoValidation.attr('data-emptyContent'),
        $phNumber = $phNoValidation.find(ACC.adduserpopup.formInputGlobal),

        $salesareaValidation = $('#cboxContent .ph-mycompany_adduser-checkbox'),
        salesareaValidationErrorMsg = $salesareaValidation.attr('data-emptyContent'),

        $emailValidation = $('#cboxContent .ph-mycompany_adduser__email'),
        emailValidationErrorMsg = $emailValidation.attr('data-emptyContent'),
        $email = $emailValidation.find(ACC.adduserpopup.formInputGlobal);

    if (ACC.validation.userName($.trim($firstName.val()))) {
      count = count + 1;
      ACC.adduserpopup.companyFieldsAddErrorMsg($firstNameValidation, firstNameValidationErrorMsg);
    }

    if (ACC.validation.userName($.trim($lastName.val()))) {
      count = count + 1;
      ACC.adduserpopup.companyFieldsAddErrorMsg($lastNameValidation, lastNameValidationErrorMsg);
    }

    if (ACC.validation.phoneNumber($.trim($phNumber.val()))) {
      count = count + 1;
      ACC.adduserpopup.companyFieldsAddErrorMsg($phNoValidation, phNoValidationErrorMsg);
    }

    if (ACC.validation.email($.trim($email.val()))) {
      count = count + 1;
      ACC.adduserpopup.companyFieldsAddErrorMsg($emailValidation, emailValidationErrorMsg);
    }

    if ($('#cboxContent .ph-checkout-checkbox').length > 0) {
      if ($('#cboxContent .ph-checkout-checkbox').is(':checked') === false) {
        count = count + 1;

        ACC.adduserpopup.companyFieldsAddErrorMsg($salesareaValidation, salesareaValidationErrorMsg);
      } else {
        ACC.adduserpopup.companyFieldsRemoveErrorMsg($salesareaValidation, salesareaValidationErrorMsg);
      }
    }

    if (count === 0) {
      return true;
    }

    return false;
  },
  /* eslint-enable max-statements*/
  validatePermissionAddNewUserForm: function() {
    var count = 0;

    $('#cboxContent .ph-mycompany_adduser-radiobuttons').each(function() {
      var $this = $(this),
          permissionSelection = $this.find('.ph-adduser_permission:checked').val(),
          permissionErrorMsg = $this.attr('data-emptyContent'),

          approverSelectField = $this.find(ACC.adduserpopup.approverSelectFieldGlobal),
          isApproverSelectDisabled = approverSelectField.is('[disabled=disabled]');

      /* eslint-disable no-undefined*/
      if (permissionSelection === '' || permissionSelection === null || permissionSelection === undefined) {
        /* eslint-enable no-undefined*/
        count = count + 1;

        ACC.adduserpopup.companyFieldsAddErrorMsg($this, permissionErrorMsg);
        $this.find(ACC.adduserpopup.formFieldWrapGlobal).addClass('ph-adduser_permission__errorborder');
        $this.find('.ph-mycompany_adduser__orderdropdown .ph-register__emptyvalue').text('');

        if (isApproverSelectDisabled) {
          ACC.adduserpopup.approverSelect(approverSelectField, $this);
        }
      } else {
        ACC.adduserpopup.companyFieldsRemoveErrorMsg($this);
        $this.find(ACC.adduserpopup.formFieldWrapGlobal).removeClass('ph-adduser_permission__errorborder');
      }

      if (permissionSelection === 'placing_and_managing_orders') {
        var $permissionInput = $this.find('.ph-permissions__placeorder-main'),
            permissionInputValue = $permissionInput.find(ACC.adduserpopup.formSelectGlobal).val(),
            permissionSelectErrorMsg = $permissionInput.attr('data-emptyContent'),
            $placeOrderSelect = $permissionInput.find('.ph-formselecttext');

        /* eslint-disable no-undefined*/
        if (permissionInputValue === '' || permissionInputValue === null || permissionInputValue === undefined) {
          /* eslint-enable no-undefined*/
          count = count + 1;

          ACC.adduserpopup.companyFieldsAddErrorMsg($permissionInput, permissionSelectErrorMsg);
          $this.find('.ph-approver_selectfield .form_field-input span[class=""]').addClass('ph-exclamation-mark');
          $this.find(ACC.adduserpopup.emptyValueGlobal).addClass('ph-ml-2');
        } else {
          ACC.adduserpopup.companyFieldsRemoveErrorMsg($permissionInput);
        }

        $placeOrderSelect.removeAttr('disabled');
      } else {
        $this.find(ACC.adduserpopup.emptyValueGlobal).removeClass('ph-ml-2');
      }
    });

    if (count === 0) {
      return true;
    }

    return false;
  },

  duplicateEmailCheck: function() {
    var $emailValidation = $('#cboxContent .ph-mycompany_adduser__email'),
        emailValidationErrorMsg = $emailValidation.attr('data-emailExists'),
        $emailInput = $('#cboxContent .ph-mycompany_adduser__email .ph-forminput'),
        emailId = $emailInput.val(),
        emailFormatInvalid = ACC.validation.email($.trim($emailInput.val()));

    if (emailFormatInvalid === false) {
      $.ajax({
        url: ACC.config.contextPath + '/my-account/manage-users/emailExists',
        type: 'GET',
        data: {
          emailId: emailId
        },
        async: false,
        dataType: 'json',
        success: function(result) {
          if (result === true) {
            $(ACC.adduserpopup.isDuplicateEmailGlobal).val('true');
            ACC.adduserpopup.companyFieldsAddErrorMsg($emailValidation, emailValidationErrorMsg);
          } else {
            $(ACC.adduserpopup.isDuplicateEmailGlobal).val('false');
            ACC.adduserpopup.companyFieldsRemoveErrorMsg($emailValidation, emailValidationErrorMsg);
          }
        }
      });
    }
  },

  selectedValue: function() {
    var selectedVal = '';

    $('.ph-company-permissions').removeClass('hidden');
    $('.ph-company-details').addClass('hidden');

    if ($('#cboxContent .ph-checkout-checkbox').length > 0) {
      $('#cboxContent input[name="selectedB2BUnit"]:checked').each(function() {
        selectedVal = selectedVal + $(this).val() + ',';
      });
    } else {
      selectedVal = $('#cboxContent input[name="selectedB2BUnit"]').val();
    }

    $('.ph-mu-selectedb2bunit').val(selectedVal);
  },

  validateWithEmail: function(validationValue, isDuplicateEmail, e) {
    ACC.adduserpopup.duplicateEmailCheck();

    if (validationValue && isDuplicateEmail === 'false') {
      ACC.adduserpopup.selectedValue();
    } else {
      e.preventDefault();
    }
  },

  validateWithoutEmail: function(validationValue, e) {
    if (validationValue) {
      ACC.adduserpopup.selectedValue();
    } else {
      e.preventDefault();
    }
  },

  addPermissionSelection: function(selectText, selectLabel) {
    selectText.addClass('ph-disabled_inputfield selectBox-disabled');
    selectLabel.addClass('ph-disabled_inputfield');
  },

  removePermissionSelection: function(selectText, selectLabel) {
    selectText.removeClass('ph-disabled_inputfield selectBox-disabled');
    selectLabel.removeClass('ph-disabled_inputfield');
  },

  approverSelect: function(approverselect, thisval) {
    approverselect.addClass('ph-remove__errorborder');
    thisval.find('.ph-approver_selectfield .form_field-input span').removeClass('ph-exclamation-mark');
    thisval.find('.ph-permissions__placeorder-main div').removeClass('ph-form__fieldwrap form_field_error ph-form_field_error');
  },

  companyFieldsAddErrorMsg: function(thisValue, errorValue) {
    thisValue.find(ACC.adduserpopup.formFieldWrapGlobal).addClass('form_field_error ph-form_field_error');
    thisValue.find(ACC.adduserpopup.emptyValueGlobal).html(errorValue);
  },

  companyFieldsRemoveErrorMsg: function(thisValue) {
    thisValue.find(ACC.adduserpopup.formFieldWrapGlobal).removeClass('form_field_error ph-form_field_error');
    thisValue.find(ACC.adduserpopup.emptyValueGlobal).html('');
  }

};

$(document).ready(function() {
  ACC.adduserpopup.adduser();

  $(document).on('click', '#ph-mu-details', function() {
    $('.ph-company-permissions').addClass('hidden');
    $('.ph-company-details').removeClass('hidden');
  });
});
